<app-view-title Title="" [isPrimaryColor]="true"></app-view-title>
<view-content [centered]="true">
  <app-information-screen [centered]="true" [secondaryColor]="true"
                          primaryContent="{{ 'Intellitrailer.Rental.BookingUpdated.Ready' | translate : 'Your rent has been updated!' }}"
                          image="/assets/Images/big-checkbox-white.png">
  </app-information-screen>
</view-content>
<view-actions>
  <button mat-raised-button color="accent" (click)="next()">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
</view-actions>

